module.exports = __webpack_public_path__ + "img/bt-more.099ef4d6.png";